const ActiveIcon = () => {
    return (
       <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 20 20" fill="none">
<g clipPath="url(#clip0_3120_2946)">
<path d="M18.3327 10.0001C18.3327 5.39771 14.6017 1.66675 9.99935 1.66675C5.39697 1.66675 1.66602 5.39771 1.66602 10.0001C1.66602 14.6024 5.39697 18.3334 9.99935 18.3334C14.6017 18.3334 18.3327 14.6024 18.3327 10.0001Z" stroke="#16A34A" strokeWidth="1.5"/>
<path d="M6.66602 10.4167L8.74935 12.5L13.3327 7.5" stroke="#16A34A" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
</g>
<defs>
<clipPath id="clip0_3120_2946">
<rect width="20" height="20" fill="white"/>
</clipPath>
</defs>
</svg>
    )
}
export default ActiveIcon